import axios from '../../../axios/index.js'

export default {
  init() {
    axios.interceptors.response.use(
      function (response) {
        return response
      },
      function (error) {
        const { response } = error

        if (response && response.status === 401) {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('tokenExpiry')
          localStorage.removeItem('loggedIn')
          localStorage.removeItem('userInfo')
        }
        throw error
      }
    )
  },
  login(username, password) {
    return axios.post('/auth/tenant/login', {
      username: username,
      password: password,
    })
  },
  validateOtp(username, otpCode) {
    return axios.post('/auth/tenant/otp', {
      username: username,
      otpCode: otpCode,
    })
  },
  resendOtp(username, password) {
    return axios.post('/auth/tenant/otp/resend', {
      username: username,
      password: password,
    })
  },
  // SSO methods - simplified
  checkSsoStatus(email) {
    return axios.post('/auth/saml/check-sso-status', { email })
  },
  selectTenant(sessionToken, tenantId) {
    return axios.post('/auth/saml/select-tenant', {
      sessionToken,
      tenantId,
    })
  },
  refreshToken() {
    return axios.post('/api/auth/refresh-token', {
      accessToken: localStorage.getItem('accessToKen'),
    })
  },
}
